import fetchAPI from '../../fetchAPI';
import type { JobStatusResponse } from './callGetJobStatus';

export type MyJobItem = JobStatusResponse & {
  createdAt?: string;
  createdBy?: string;
  payload?: any;
};

export interface ListJobsParams {
  limit?: number;
  offset?: number;
  jobType?: string[];
  status?: string[];
  dateFrom?: string;
  dateTo?: string;
  createdBy?: string[];
}

export interface ListJobsResponse {
  total: number;
  jobs: MyJobItem[];
}

function buildQuery(params: ListJobsParams): string | undefined {
  const parts: string[] = [];
  if (params.limit != null) parts.push(`limit=${params.limit}`);
  if (params.offset != null) parts.push(`offset=${params.offset}`);
  if (params.jobType?.length) parts.push(`jobType=${encodeURIComponent(params.jobType.join(','))}`);
  if (params.status?.length) parts.push(`status=${encodeURIComponent(params.status.join(','))}`);
  if (params.dateFrom) parts.push(`dateFrom=${encodeURIComponent(params.dateFrom)}`);
  if (params.dateTo) parts.push(`dateTo=${encodeURIComponent(params.dateTo)}`);
  if (params.createdBy?.length) parts.push(`createdBy=${encodeURIComponent(params.createdBy.join(','))}`);
  return parts.length ? parts.join('&') : undefined;
}

export const callListJobs = async (params: ListJobsParams = {}): Promise<iResponse<ListJobsResponse>> => {
  const response = await fetchAPI<ListJobsResponse>({
    method: 'GET',
    route: 'jobs',
    queryString: buildQuery(params)
  });
  return response;
};

// Thin wrapper for the notification bell: returns just the jobs array.
export const callGetMyJobs = async (limit?: number): Promise<iResponse<MyJobItem[]>> => {
  const response = await callListJobs({ limit });
  return {
    ...response,
    data: response.code === 200 && response.data ? response.data.jobs : ([] as MyJobItem[])
  } as iResponse<MyJobItem[]>;
};

export default callGetMyJobs;
